import Immutable from 'seamless-immutable';
import { PREFERENCES_TYPES } from './actions';
import { createReducer } from '../../libs/saga-utils';

const DEFAULT_STATE = {
  selectedEvent: {},

  company: undefined,
  companyEvent: undefined,
  companyRegistration: undefined,
  lastRentedMaterial: undefined,
  weekend: 'w1',
  preferredLang: 'en'
};

const ACTIONS = {
  [PREFERENCES_TYPES.SET_PREFERENCE]: setPreference,
  [PREFERENCES_TYPES.RESET]: reset
};

// CREATE
function setPreference(state, { payload }) {
  const { key, value } = payload;
  let newState = {};
  newState[key] = value;

  return state.merge(newState);
}

function reset(state, action) {
  return Immutable(DEFAULT_STATE);
}

const preferencesReducer = createReducer(Immutable(DEFAULT_STATE), ACTIONS);

export default preferencesReducer;
